<template>
  <Navbar />
  <Home />
  <About />
  <Resume />
  <Work />
  <Contact />
  <Footer />
</template>
<script>
import Navbar from "./components/Navbar.vue";
import About from "./components/About.vue";
import Resume from "./components/Resume.vue";
import Work from "./components/Work.vue";
import Contact from "./components/Contact.vue";
import Footer from "./components/Footer.vue";
import Home from "./components/Home.vue";
export default {
  components: { Navbar, Footer, About, Work, Contact, Resume, Home },
};
</script>

<style>
* {
  scroll-behavior: smooth !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
body::-webkit-scrollbar {
  display: none;
}

#nav a {
  /* font-weight: bold; */
  /* color: #101010; */
  text-decoration: none;
}

.textBlue {
  color: #1e90ff;
}

.maxWidth {
  max-width: 1220px;
}

.textBlue {
  color: #1e90ff;
}

.dropShadow {
  height: 450px;
  text-align: center;
}

.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge add Firefox */
.scrollbar-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
</style>
